/**
 * @NOTE
 * @InitialValues  - are equivalent to Types When in Used in Type Script
 */
export const initialValue = {
  title: "Please replace title and save to show this FAQ",
  text: "Please replace text and save to show this FAQ",
};

export const testValue = [
  { title: "Lorem Ipsum", text: "Lorem Ipsum", _id: "1" },
  { title: "Lorem Ipsum1", text: "Lorem Ipsum1", _id: "2" },
  { title: "Lorem Ipsum2", text: "Lorem Ipsum2", _id: "3" },
];
